// import MapComponent from "components/MapComponent/MapComponent";
// import asset from "json/assets";
// import MapWrapper from "layout/MapWrapper/MapWrapper";
import styles from "styles/component/NoItemFound.module.scss";
// import CustomButton from 'ui/CustomButton/CustomButton';
// import { lazy } from "react";
import Lottie from "lottie-react";
import groovyWalkAnimation from "json/map_loader_lottie.json";
export default function MapLoader (props) {

  return (
    //  <MapWrapper>
      <div className={styles.match_wrap_full}>
        <div className={styles.match_wrap}>
            <Lottie animationData={groovyWalkAnimation} loop={true} />
          {/* <i className={styles.srch_icon}>
            <img src={asset.nodata} alt="" />
          </i> */}
          <p className={styles.blue_txt}>Please Wait</p>
          <p className={styles.gray_txt}>Map is loading...</p>
          {/* <CustomButton>Cancel</CustomButton> */}
          {/* <Link to={"#"} className={styles.blue_btn}>
            Cancel
          </Link> */}
        </div>
      </div>
    // </MapWrapper>
  );
}
